import React, { useState, useEffect } from 'react';

import axios from 'axios';
import CabecalhoProjeto from './components/CabecalhoProjeto';
import ProcessoForm from './components/ProcessoForm';
import { API_URL } from '../api'
import AcoesANP from './components/ACOES_ANP';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import AcoesPosProducaoResumo from './components/AcoesPosProducaoResumo';
import { Routes, Route } from 'react-router-dom';
import DuvidasSugestoes from './components/DuvidasSugestoes';
import SugestoesRecebidas from './components/SugestoesRecebidas';
import { Button } from '@mui/material';





const processosOrdem = [
  'Pré-Impressão',
  'Impressão',
  'Laminadora',
  'Serigrafia',
  'Empastadeira',
  'Acopladeira',
  'Onduladeira',
  'Corte e Vinco',
  'Hotstamping',
  'Destaques',
  'Fechadora',
  'Fresa',
  'Caixa Rígida',
  'Bancada Caixa Rígida',
  'Bancada Clientes Diversos',
];



function App() {

  
  
  const [anps, setANPs] = useState([]);
  const [lixeira, setLixeira] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [cabecalho, setCabecalho] = useState({});
  const [dadosForm, setDadosForm] = useState({});
  const [anpSelecionada, setAnpSelecionada] = useState(null);
  const [acoesProcessos, setAcoesProcessos] = useState({});

  const [showLixeira, setShowLixeira] = useState(false);
  const [arquivoAnexo, setArquivoAnexo] = useState('');
  const [mostrarResumoAcoes, setMostrarResumoAcoes] = useState(false);
  const [showDuvidas, setShowDuvidas] = useState(false);
  const [showSugestoesRecebidas, setShowSugestoesRecebidas] = useState(false);



  
  const [modalAcoesAberto, setModalAcoesAberto] = useState(false);
  const [processoSelecionadoParaAcoes, setProcessoSelecionadoParaAcoes] = useState('');


const normalizeNome = (str) => {
  if (Array.isArray(str)) {
    return str.map(s =>
      typeof s === 'string'
        ? s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[\s\-]/g, "_").replace(/_+/g, "_").toLowerCase().trim()
        : ''
    ).filter(Boolean);
  }

  if (typeof str !== 'string') {
    console.warn('❌ normalizeNome recebeu tipo inválido:', str);
    return '';
  }

  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[\s\-]/g, "_")
    .replace(/_+/g, "_")
    .toLowerCase()
    .trim();
};








const handleAbrirAcoes = (processo) => {
  if (processo === 'TODOS') {
    // Exibir todas as ações preenchidas da ANP selecionada
    console.log('🧾 Abrindo resumo de ações de todos os processos.');
    // você pode preparar um outro modal aqui
  } else {
    setProcessoSelecionadoParaAcoes(processo);
    setModalAcoesAberto(true);
  }
};





const carregarLixeiraBackend = async () => {
  try {
    const response = await axios.get(`${API_URL}/anp/lixeira`);
    setLixeira(response.data || []);
  } catch (err) {
    console.error("Erro ao carregar lixeira:", err);
  }
};







useEffect(() => {
  const processoSalvo = sessionStorage.getItem('processoSelecionadoParaAcoes');
  const abrirModal = sessionStorage.getItem('abrirModalAcoesDireto');
  console.log('🕵️ Verificando sessionStorage para abrir modal diretamente:', {
    processoSalvo,
    abrirModal
  });

  if (processoSalvo && abrirModal === 'true') {
    console.log('✅ Abrindo modal diretamente para processo:', processoSalvo);
    setProcessoSelecionadoParaAcoes(processoSalvo);
    setModalAcoesAberto(true);
    sessionStorage.removeItem('processoSelecionadoParaAcoes');
    sessionStorage.removeItem('abrirModalAcoesDireto');
  } else {
    console.log('⛔ Nenhuma instrução para abrir modal diretamente');
  }
}, []);














useEffect(() => {
  const anpIdSalvo = sessionStorage.getItem('anpSelecionadaId');
  if (anpIdSalvo) {
    handleAbrirANP({ id: anpIdSalvo });
    setShowForm(true);
    sessionStorage.removeItem('anpSelecionadaId'); // limpa após uso
  }
}, []);





useEffect(() => {
  const carregarLixeiraDoBackend = async () => {
    try {
      const response = await axios.get(`${API_URL}/anp/lixeira`);
      setLixeira(response.data || []);
    } catch (err) {
      console.error("Erro ao carregar lixeira:", err);
    }
  };

  carregarLixeiraDoBackend();
}, []);









useEffect(() => {
  const carregarANPsDoBackend = async () => {
    try {
      const response = await axios.get(`${API_URL}/anp/listar`);
      const ordenadas = [...(response.data || [])].sort((a, b) => {
  const nomeA = (a.nomeCliente || '').toLowerCase();
  const nomeB = (b.nomeCliente || '').toLowerCase();
  return nomeA.localeCompare(nomeB);
});
setANPs(ordenadas);

    } catch (err) {
      console.error("Erro ao carregar ANPs:", err);
    }
  };

  carregarANPsDoBackend();
}, []);




  // Função para excluir todos os itens da lixeira
const handleExcluirTudo = async () => {
  if (lixeira.length === 0) {
    alert('A lixeira já está vazia!');
    return;
  }

  if (window.confirm('Tem certeza que deseja excluir TODOS os itens da lixeira permanentemente? Esta ação não pode ser desfeita!')) {
    try {
      await axios.post(`${API_URL}/anp/limpar-lixeira`);
      setLixeira([]);
      alert('Todos os itens foram excluídos permanentemente!');
    } catch (err) {
      console.error("Erro ao limpar lixeira:", err);
      alert("Erro ao limpar a lixeira");
    }
  }
};


const handleFileUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append('arquivo', file); // 👈 ajuste aqui

  if (!anpSelecionada?.id) {
    alert("Erro: Nenhuma ANP foi criada ou selecionada. Salve a ANP primeiro.");
    return;
  }

  try {
    const processo = cabecalho?.op || 'geral';

    const response = await axios.post(`${API_URL}/anp/upload-desenho`, formData, {
      headers: {
        'x-processo': processo.toLowerCase(),
        'x-anpid': anpSelecionada?.id || '',
        'x-filename': file.name
      }
    });

  const nomeFinal = file.name.replace(/\s/g, '_');



    if (response.data.sucesso) {
      const fileUrl = `/Anexos/cabecalho/${nomeFinal}`;
      setArquivoAnexo(fileUrl);
      setCabecalho(prev => ({ ...prev, urlArquivo: fileUrl }));
      alert('Arquivo enviado com sucesso!');
    } else {
      alert('Erro ao enviar o arquivo');
    }

  } catch (error) {
    console.error('Erro ao fazer upload do arquivo:', error);
    alert('Erro ao fazer upload do arquivo');
  }
};



  // Filtros
  const [filtroNome, setFiltroNome] = useState('');
  const [filtroIM, setFiltroIM] = useState('');
  const [filtroCV, setFiltroCV] = useState('');
  const [filtroOP, setFiltroOP] = useState('');
  const [filtroDescricao, setFiltroDescricao] = useState('');


  // Login
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Definindo o estado de usuarioAtual
  const [usuarioAtual, setUsuarioAtual] = useState(null); // Adicionando o estado de usuarioAtual
const tiposUsuario = Array.isArray(usuarioAtual?.tipo)
  ? normalizeNome(usuarioAtual.tipo)
  : typeof usuarioAtual?.tipo === 'string'
    ? normalizeNome(usuarioAtual.tipo.split(',').map(t => t.trim()))
    : [];





const usuarioTemAcesso = (proc) => {
  const normal = normalizeNome;
  const processoNorm = normal(usuarioAtual?.processo);
  const procNorm = normal(proc);

  return (
    tiposUsuario.includes('admin') ||
    tiposUsuario.includes('projetos') ||
    tiposUsuario.includes('qualidade') ||
    tiposUsuario.includes(procNorm) ||
    tiposUsuario.includes(processoNorm)
  );
};



  

  useEffect(() => {
    const usuarioSalvo = localStorage.getItem('usuarioAtual');
    if (usuarioSalvo) {
      setUsuarioAtual(JSON.parse(usuarioSalvo));


const usuario = JSON.parse(usuarioSalvo);

// Trata tipo como array mesmo que venha como string
const tipoArray = Array.isArray(usuario.tipo)
  ? usuario.tipo
  : typeof usuario.tipo === 'string'
    ? usuario.tipo.split(',').map(t => t.trim())
    : [];

usuario.tipo = tipoArray;
setUsuarioAtual(usuario);



      setIsAuthenticated(true);
    } else {
      alert("Você precisa estar logado no GPD para acessar o ANP.");
      window.location.href = "/"; // ou redirecione para o login do GPD
    }
  }, []);
  
  


  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('isAuthenticatedANP');
    localStorage.removeItem('usuarioAtualANP');
  };
  

const handleCabecalhoChange = (campo, valor) => {
  let novoValor = valor;






if (campo === 'op') {
  let raw = valor.toUpperCase();

  // Se o usuário está apagando tudo, permite campo vazio
  if (raw === '') {
    novoValor = '';
  } else if (raw === 'F') {
    novoValor = 'FAA/';
  } else if (raw === 'I') {
    novoValor = 'IMP/';
  } else if (raw.startsWith('FAA/') || raw.startsWith('IMP/')) {
    novoValor = raw.replace(/[^A-Z0-9/]/g, '');
  } else {
    // Bloqueia digitação inválida fora do padrão
    novoValor = '';
  }
}







if (campo === 'codigoIM') {
  let raw = valor.toUpperCase().replace(/^IM/, '');

  const numeros = raw.replace(/[^0-9]/g, '').slice(0, 4);
  const letras = raw.replace(/[^A-Z]/g, '').slice(0, 2);

  novoValor = 'IM';
  if (numeros.length > 0) novoValor += numeros;
  if (numeros.length === 4 && letras.length > 0) novoValor += letras;
}


if (campo === 'codigoCV') {
  let raw = valor.toUpperCase().replace(/^CV/i, '');

  // Se o usuário está apagando e removeu o ponto e o sistema está forçando ele de volta, previne isso:
  if (raw.length <= 4) {
    novoValor = 'CV' + raw.replace(/[^0-9]/g, '').slice(0, 4);
  } else {
    // Separar partes
    const numeros = raw.slice(0, 4).replace(/\D/g, '');
    let resto = raw.slice(4);

    let letras = resto.replace(/[^A-Z]/g, '').slice(0, 3);
    let numerosFinais = resto.slice(3).replace(/\D/g, '').slice(0, 3);

    // Monta com ponto só se tiver pelo menos uma letra
    novoValor = `CV${numeros}`;
    if (letras.length > 0 || numerosFinais.length > 0) {
      novoValor += `.${letras}${numerosFinais}`;
    }
  }
}


  setCabecalho(prev => ({ ...prev, [campo]: novoValor }));
};









const handleAbrirANP = async (anp) => {

  const dados = anp.dados || {};
  const processos = anp.processos?.length ? anp.processos : Object.keys(dados);





setCabecalho(prev => ({
  ...prev,
  ...anp.cabecalho,
  op: anp.op ?? anp.cabecalho?.op ?? '',
  codigoIM: anp.codigoIM ?? anp.cabecalho?.codigoIM ?? '',
  codigoCV: anp.codigoCV ?? anp.cabecalho?.codigoCV ?? '',
  descricaoProduto: anp.descricaoProduto ?? anp.cabecalho?.descricaoProduto ?? '',
  dataAberturaOP: anp.cabecalho?.dataAberturaOP ?? '',
  dataEntrega: anp.cabecalho?.dataEntrega ?? ''
}));

// 🛠️ Garante que o PDF será exibido ao reabrir ANP
if (!anp.cabecalho?.urlArquivo && anp.arquivo) {
  setCabecalho(prev => ({ ...prev, urlArquivo: anp.arquivo }));
}









  
  setDadosForm({ ...dados });

  

  setAnpSelecionada({ ...anp, processos });
  if (anp?.id) {
  try {
    const responseAcoes = await axios.get(`${API_URL}/anp/acoes-por-anp/${anp.id}`);
    console.log('🔴 responseAcoes.data:', responseAcoes.data);

const processosANP = anp?.processos || Object.keys(anp.dados || {});
const acoesRaw = responseAcoes.data || [];

const mapaAcoes = {};
acoesRaw.forEach(acao => {
  const proc = (acao.processo || '').trim().toLowerCase();
  mapaAcoes[proc] = Array.isArray(acao.status) ? acao.status : [];
});


const todasFormatadas = processosANP.map(proc => ({
  processo: proc,
  processoNormalizado: normalizeNome(proc),
  status: mapaAcoes[normalizeNome(proc)] || []
}));


setAcoesProcessos(todasFormatadas);


  } catch (err) {
    console.warn('❌ Erro ao buscar ações para ANP:', err);
  }
}

  setArquivoAnexo(anp.arquivo || '');
  setShowForm(true);
};





const handleRemoverANP = async (id) => {
  const anpRemovida = anps.find(a => a.id === id);
  if (anpRemovida && window.confirm('Deseja realmente mover esta ANP para a lixeira?')) {
    const novas = anps.filter(a => a.id !== id);
    const novaLixeira = [anpRemovida, ...lixeira];
    setANPs(novas);
    setLixeira(novaLixeira);

    try {
      await fetch(`${API_URL}/anp/mover-para-lixeira`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...anpRemovida,
          dados: anpRemovida.dados || {},
          cabecalho: anpRemovida.cabecalho || {},
          arquivo: anpRemovida.arquivo || null,
          codigoCV: anpRemovida.codigoCV || '',
          data: anpRemovida.data || ''
        })
      });
    } catch (error) {
      console.error('Erro ao mover ANP para lixeira no backend:', error);
    }
  }
};

  

const handleDuplicarANP = async (anp) => {
  const duplicada = {
    ...anp,
    id: Date.now(),
    data: new Date().toLocaleString(),
  };
  try {
    await axios.post(`${API_URL}/anp/salvar`, duplicada);
    const atualizada = await axios.get(`${API_URL}/anp/listar`);
    setANPs(atualizada.data || []);
  } catch (error) {
    console.error("Erro ao duplicar ANP:", error);
    alert("Erro ao duplicar ANP");
  }
};


const handleRestaurarANP = async (id) => {
  const anpRestaurada = lixeira.find(a => a.id === id);
  if (anpRestaurada) {
    try {
await axios.post(`${API_URL}/anp/restaurar-lixeira`, {
  ...anpRestaurada,
  dados: anpRestaurada.dados || {},
  arquivo: anpRestaurada.arquivo || null,
  codigoCV: anpRestaurada.codigoCV || '',
  data: anpRestaurada.data || '',
  cabecalho: anpRestaurada.cabecalho || {}
});

// 🔁 Após restaurar, salva também as ações (se houver)
if (Array.isArray(anpRestaurada.acoes)) {
  await axios.post(`${API_URL}/anp/salvar-acoes`, {
    anpId: anpRestaurada.id,
    acoes: anpRestaurada.acoes
  });
}



      const atualizada = await axios.get(`${API_URL}/anp/lixeira`);
      setLixeira(atualizada.data || []);

      const atualizadaANPs = await axios.get(`${API_URL}/anp/listar`);
      setANPs(atualizadaANPs.data || []);

      // ✅ impede de abrir automaticamente
      setShowForm(false);
      setAnpSelecionada(null);
      const anpFinal = (atualizadaANPs.data || []).find(a => a.id === anpRestaurada.id);
if (anpFinal) {
  handleAbrirANP(anpFinal); // ✅ Usa a versão atualizada do backend (com datas)
}



    } catch (err) {
      console.error("Erro ao restaurar ANP:", err);
      alert("Erro ao restaurar ANP");
    }
  }
};







const handleExcluirPermanentemente = async (id) => {
  if (window.confirm('Excluir permanentemente esta ANP? Isso não pode ser desfeito!')) {
    try {
      const novaLixeira = lixeira.filter(a => a.id !== id);
      await axios.post(`${API_URL}/anp/salvar-lixeira`, novaLixeira);
      const atualizada = await axios.get(`${API_URL}/anp/lixeira`);
      setLixeira(atualizada.data || []);
    } catch (err) {
      console.error("Erro ao excluir permanentemente:", err);
      alert("Erro ao excluir permanentemente");
    }
  }
};








const handleSalvar = async (dadosDoForm) => {
  if (!cabecalho.nomeCliente || !cabecalho.nomeCliente.trim()) {
    alert('Preencha o nome do cliente antes de salvar!');
    return;
  }

  if (!anpSelecionada?.id) {
    alert("Erro: ID da ANP não está definido.");
    return;
  }

  const idAtual = anpSelecionada.id;
  const dataAtual = anpSelecionada?.data || new Date().toLocaleString();


  // ✅ Insere os campos de data no próprio objeto cabecalho ANTES de salvar
const cabecalhoComDatas = {
  ...cabecalho,
  urlArquivo: cabecalho.urlArquivo || anpSelecionada?.cabecalho?.urlArquivo || '',
  dataAberturaOP: cabecalho?.dataAberturaOP ?? anpSelecionada?.cabecalho?.dataAberturaOP ?? '',
  dataEntrega: cabecalho?.dataEntrega ?? anpSelecionada?.cabecalho?.dataEntrega ?? ''
};






  console.log("📦 dados recebidos do formulário:", dadosDoForm);

  const dadosFiltradosDebug = Object.entries(dadosDoForm)
    .filter(([chave, valor]) => typeof valor === 'object' && valor !== null)
    .map(([chave, valor]) => [chave, valor.houveDificuldades]);

  console.log("🔎 Processos e 'houveDificuldades':", Object.fromEntries(dadosFiltradosDebug));


// Mantém processos antigos, atualiza apenas os modificados com novo alteradoPor
const dadosAntigos = anpSelecionada?.dados || {};
const dadosComUsuario = {};

// percorre todos os processos (novos ou existentes)
for (const processo of new Set([...Object.keys(dadosAntigos), ...Object.keys(dadosDoForm)])) {
  const dadosNovos = dadosDoForm[processo] || {};
  const dadosAntigosProcesso = dadosAntigos[processo] || {};

  const houveMudanca = JSON.stringify(dadosAntigosProcesso) !== JSON.stringify(dadosNovos);

  dadosComUsuario[processo] = {
    ...dadosNovos,
    alteradoPor: houveMudanca
      ? (usuarioAtual?.nome || 'Desconhecido')
      : (dadosAntigosProcesso.alteradoPor || '')
  };
}




const anpAtualizada = {
  id: idAtual,
  data: dataAtual,
  nomeCliente: cabecalho.nomeCliente || '',
  codigoIM: cabecalho.codigoIM || '',
  codigoCV: cabecalho.codigoCV || '',
  descricaoProduto: cabecalho.descricaoProduto || '',
  op: cabecalho.op || '',
  cabecalho: {
    ...cabecalhoComDatas,
    urlArquivo: arquivoAnexo || cabecalho.urlArquivo || ''
  },
  dados: dadosComUsuario,
  arquivo: cabecalho.urlArquivo || arquivoAnexo || '',
  urlArquivo: cabecalho.urlArquivo || arquivoAnexo || '',

  processos: Object.keys(dadosComUsuario)
};

console.log('🧠 Enviando ao backend:', anpAtualizada.cabecalho);



  try {
    await axios.post(`${API_URL}/anp/salvar`, anpAtualizada);
    const atualizadas = await axios.get(`${API_URL}/anp/listar`);
    const novaLista = [...(atualizadas.data || [])].sort((a, b) => {
      const nomeA = (a.nomeCliente || '').toLowerCase();
      const nomeB = (b.nomeCliente || '').toLowerCase();
      return nomeA.localeCompare(nomeB);
    });
    setANPs(novaLista);


    const anpRecarregada = novaLista.find(a => a.id === idAtual);
    setAnpSelecionada(anpRecarregada);
    console.log('🧠 Após salvar, cabecalho original:', anpRecarregada.cabecalho);

setCabecalho({
  ...anpRecarregada?.cabecalho || {},
  dataAberturaOP: anpRecarregada?.cabecalho?.dataAberturaOP || cabecalho.dataAberturaOP || '',
  dataEntrega: anpRecarregada?.cabecalho?.dataEntrega || cabecalho.dataEntrega || '',
  urlArquivo: anpRecarregada?.cabecalho?.urlArquivo || anpRecarregada?.arquivo || cabecalho.urlArquivo || ''
});
setArquivoAnexo(anpRecarregada?.arquivo || '');






    setDadosForm({ ...anpRecarregada.dados || {} });
    setShowForm(true);

    return { sucesso: true };
  } catch (error) {
    console.error("Erro ao salvar ANP:", error);
    alert("Erro ao salvar ANP");
  }
};








const anpsFiltradas = anps.filter(anp =>
  (!filtroNome || (anp.nomeCliente || '').toLowerCase().includes(filtroNome.toLowerCase())) &&
  (!filtroIM || (anp.codigoIM || '').toLowerCase().includes(filtroIM.toLowerCase())) &&
  (!filtroCV || (anp.codigoCV || '').toLowerCase().includes(filtroCV.toLowerCase())) &&
  (!filtroOP || (anp.op || '').toLowerCase().includes(filtroOP.toLowerCase())) &&
  (!filtroDescricao || (anp.descricaoProduto || '').toLowerCase().includes(filtroDescricao.toLowerCase()))
);


const handleNovo = () => {
  const novoId = Date.now();
  setCabecalho({});
  setDadosForm({});
  setAnpSelecionada({
  id: novoId,
  data: new Date().toLocaleString(),
  processos: [
    normalizeNome(usuarioAtual?.processo)
  ].filter(Boolean)
});

  setShowForm(true);
};


  const handleImprimir = () => {
    window.print();
  };

 
if (showSugestoesRecebidas) {
  console.log("📩 Renderizando tela de Sugestões Recebidas");
  return (
    <div style={{ maxWidth: 950, margin: 'auto', padding: 24 }}>
      <button
        onClick={() => {
          console.log('🔙 Botão "Voltar das Sugestões Recebidas" clicado');
          setShowSugestoesRecebidas(false);
        }}
        style={{
          marginBottom: 18,
          background: '#eee',
          border: 0,
          borderRadius: '7px',
          padding: '8px 18px',
          cursor: 'pointer'
        }}
      >
        ← Voltar
      </button>
      <SugestoesRecebidas usuarioAtual={usuarioAtual} />

    </div>
  );
}

if (showDuvidas) {
  console.log("📘 Renderizando tela de Dúvidas e Sugestões");
  return (
    <div style={{ maxWidth: 950, margin: 'auto', padding: 24 }}>
      <button
        onClick={() => {
          console.log('🔙 Botão "Voltar das Dúvidas" clicado');
          setShowDuvidas(false);
        }}
        style={{
          marginBottom: 18,
          background: '#eee',
          border: 0,
          borderRadius: '7px',
          padding: '8px 18px',
          cursor: 'pointer'
        }}
      >
        ← Voltar
      </button>
      <DuvidasSugestoes />
    </div>
  );
}


if (mostrarResumoAcoes) {




  return (
    <AcoesPosProducaoResumo
      mostrar={mostrarResumoAcoes}
      onVoltarAoProjeto={() => {
        setMostrarResumoAcoes(false);
        setShowForm(true);
      }}
      anpSelecionada={anpSelecionada}
      dadosForm={dadosForm}
    />
  );
}





  if (showLixeira) {
    return (
      <div style={{ maxWidth: 950, margin: 'auto', padding: 24 }}>
        <h2 style={{ textAlign: 'center', marginBottom: 18 }}>Lixeira de ANPs</h2>
        <div style={{ textAlign: 'right', marginBottom: '20px' }}>
          <button
            onClick={handleExcluirTudo}
            style={{
              padding: '8px 20px',
              backgroundColor: '#ff4444',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
            disabled={lixeira.length === 0}
          >
            Excluir Tudo
          </button>
        </div>
        {lixeira.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#888', fontSize: 16, marginTop: 40 }}>Lixeira vazia.</div>
        ) : (
          <table style={{ width: '100%', background: '#fff', borderRadius: 10, overflow: 'hidden', boxShadow: '0 1px 8px #ececec', fontSize: 15 }}>
            <thead>
              <tr style={{ background: '#fde4e1' }}>
                <th style={{ padding: '10px 8px', textAlign: 'left' }}>Nome do Cliente</th>
                <th style={{ padding: '10px 8px', textAlign: 'left' }}>Código IM</th>
                <th style={{ padding: '10px 8px', textAlign: 'left' }}>Código CV</th>
                <th style={{ padding: '10px 8px', textAlign: 'left' }}>OP</th>
                <th style={{ padding: '10px 8px', textAlign: 'left' }}>Data</th>
                <th style={{ width: 120 }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {lixeira.map(anp => (
                <tr key={anp.id} style={{ borderTop: '1px solid #fbb' }}>
                  <td style={{ padding: '7px 8px' }}>{anp.nomeCliente}</td>
                  <td style={{ padding: '7px 8px' }}>{anp.codigoIM}</td>
                  <td style={{ padding: '7px 8px' }}>{anp.codigoCV}</td>
                  <td style={{ padding: '7px 8px' }}>{anp.op}</td>
                  <td style={{ padding: '7px 8px', color: '#888', fontSize: 14 }}>{anp.data}</td>
                  <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                    <button
                      onClick={() => handleRestaurarANP(anp.id)}
                      style={{
                        background: '#e3fbe4', border: '1px solid #9ce3a3', borderRadius: 7,
                        padding: '4px 10px', marginRight: 7, cursor: 'pointer',
                        color: '#0a7e1e', fontWeight: 'bold'
                      }}
                    >♻️ Restaurar</button>
                    <button
                      onClick={() => handleExcluirPermanentemente(anp.id)}
                      style={{
                        background: '#ffe6e6', border: '1px solid #faa', borderRadius: 7,
                        padding: '4px 12px', cursor: 'pointer', color: '#b00', fontWeight: 'bold'
                      }}
                    >Excluir</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <div style={{ textAlign: 'center', marginTop: 32 }}>
          <button
            onClick={() => setShowLixeira(false)}
            style={{
              padding: '9px 28px', borderRadius: 18, background: '#ececec', border: 0,
              color: '#1d1d1d', fontWeight: 'bold', fontSize: 17, cursor: 'pointer'
            }}
          >← Voltar</button>
        </div>
      </div>
    );
  }





  return (
    <div style={{ maxWidth: 950, margin: 'auto', padding: 24 }}>



{/*MODAL DE EDIÇÕES AÇÕES ANP*/}
<Dialog open={modalAcoesAberto} onClose={() => setModalAcoesAberto(false)} fullWidth maxWidth="md">
  <DialogTitle>Ações Pós Produção</DialogTitle>
  <DialogContent>
    <AcoesANP
      processo={processoSelecionadoParaAcoes}
      anpSelecionada={anpSelecionada}
      onFechar={() => setModalAcoesAberto(false)}
    />
  </DialogContent>
</Dialog>



    {usuarioAtual?.nome && (
      <div style={{ fontWeight: 'bold', marginBottom: 10 }}>
        Usuário logado: {usuarioAtual.nome}
      </div>
    )}

  
      {/* Botão de Imprimir Relatório */}
<button
  onClick={() => {
    console.log('🖨️ Botão "Imprimir Relatório" clicado');
    handleImprimir();
  }}

        style={{
          padding: '10px 20px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', marginBottom: '20px'
        }}
      >
        Imprimir Relatório
      </button>
      

{/* Botão de Dúvidas e Sugestões */}
<button
  onClick={() => {
    console.log('🟦 Botão "Dúvidas e Sugestões" clicado');
    setShowForm(false);
    setMostrarResumoAcoes(false);
    setShowLixeira(false);
    setShowDuvidas(true);
  }}

  style={{
    marginLeft: 16,
    padding: '10px 20px',
    backgroundColor: '#1976D2',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    marginBottom: '20px',
    fontWeight: 'bold'
  }}
>
  Dúvidas e Sugestões
</button>





{usuarioAtual?.login === 'gerson.souza' && (
  <Button
    onClick={() => {
      console.log('🟨 Botão "Ver Sugestões" clicado');
      setShowForm(false);
      setMostrarResumoAcoes(false);
      setShowLixeira(false);
      setShowDuvidas(false);
      setShowSugestoesRecebidas(true);
    }}
    variant="outlined"
    sx={{ ml: 2 }}
  >
    Ver Sugestões
  </Button>
)}








      {!showForm ? (
        <>
          <h2 style={{ textAlign: 'center', marginBottom: 18 }}>ANPs Preenchidas</h2>
          <div style={{ display: 'flex', gap: 18, marginBottom: 16, flexWrap: 'wrap', justifyContent: 'center' }}>
            <input
              placeholder="Filtrar por Nome do Cliente"
              value={filtroNome}
              onChange={e => setFiltroNome(e.target.value)}
              style={{ padding: 6, borderRadius: 6, border: '1px solid #bbb', minWidth: 160 }}
            />
            <input
              placeholder="Filtrar por Código IM"
              value={filtroIM}
              onChange={e => setFiltroIM(e.target.value)}
              style={{ padding: 6, borderRadius: 6, border: '1px solid #bbb', minWidth: 120 }}
            />
            <input
              placeholder="Filtrar por Código CV"
              value={filtroCV}
              onChange={e => setFiltroCV(e.target.value)}
              style={{ padding: 6, borderRadius: 6, border: '1px solid #bbb', minWidth: 120 }}
            />
            <input
              placeholder="Filtrar por OP"
              value={filtroOP}
              onChange={e => setFiltroOP(e.target.value)}
              style={{ padding: 6, borderRadius: 6, border: '1px solid #bbb', minWidth: 90 }}
            />

            <input
              placeholder="Filtrar por Código/Descrição do Produto"
              value={filtroDescricao}
              onChange={e => setFiltroDescricao(e.target.value)}
              style={{ padding: 6, borderRadius: 6, border: '1px solid #bbb', minWidth: 240 }}
            />


<button
  onClick={() => {
    console.log('🟫 Botão "Limpar Filtros" clicado');
    setFiltroNome(''); setFiltroIM(''); setFiltroCV(''); setFiltroOP('');
  }}

              style={{ padding: '6px 18px', borderRadius: 6, background: '#eee', border: '1px solid #bbb', fontWeight: 500 }}
            >Limpar Filtros</button>
            {tiposUsuario.some(t => ['admin', 'projetos', 'qualidade'].includes(t)) && (

<button
  onClick={() => {
    console.log('🟧 Botão "Ver Lixeira" clicado');
    setShowLixeira(true);
  }}

                style={{
                  padding: '6px 18px', borderRadius: 6, background: '#ffe6e6', border: '1px solid #eaa',
                  fontWeight: 600, color: '#b00', marginLeft: 16
                }}
              >Ver Lixeira</button>
            )}


          </div>
<div style={{ margin: '0 0 24px 0' }}>

  {!tiposUsuario.includes('comercial') && (
    <div style={{ textAlign: 'center', marginBottom: 24 }}>
<button
  onClick={() => {
    console.log('🟩 Botão "Criar uma Nova ANP" clicado');
    handleNovo();
  }}

        style={{
          padding: '12px 30px',
          borderRadius: 18,
          background: '#2fbb59',
          border: 0,
          color: '#fff',
          fontWeight: 'bold',
          fontSize: 18,
          boxShadow: '0 1px 4px #cfc',
          cursor: 'pointer'
        }}
      >
        Criar uma Nova ANP
      </button>
    </div>
  )}


            {anpsFiltradas.length === 0 ? (
              <div style={{ textAlign: 'center', color: '#888', fontSize: 16, marginTop: 40 }}>Nenhuma ANP encontrada.</div>
            ) : (
              <table style={{ width: '100%', background: '#fff', borderRadius: 10, overflow: 'hidden', boxShadow: '0 1px 8px #ececec', fontSize: 15 }}>
                <thead>
                  <tr style={{ background: '#f2f2fc' }}>
                    <th style={{ padding: '10px 8px', textAlign: 'left' }}>Nome do Cliente</th>
                    <th style={{ padding: '10px 8px', textAlign: 'left' }}>Código IM</th>
                    <th style={{ padding: '10px 8px', textAlign: 'left' }}>Código CV</th>
                    <th style={{ padding: '10px 8px', textAlign: 'left' }}>OP</th>
                    <th style={{ padding: '10px 8px', textAlign: 'left' }}>Data</th>
                    {tiposUsuario.some(t => ['admin', 'projetos', 'qualidade'].includes(t)) && (

  <th style={{ width: 100 }}>Ações</th>
)}

                  </tr>
                </thead>
                <tbody>
                  {anpsFiltradas.map(anp => (
                    <tr key={anp.id} style={{ borderTop: '1px solid #eee' }}>
                  <td
                    style={{ padding: '7px 8px', cursor: 'pointer' }}
                    onClick={(e) => {
                      const tag = e.target.tagName.toLowerCase();
                      if (!['button', 'svg', 'path', 'a'].includes(tag)) {
                        handleAbrirANP(anp);
                      }
                    }}
                    title="Clique para visualizar ou editar"
                  >
                    {anp.nomeCliente}
                  </td>


                  <td
                style={{ padding: '7px 8px', cursor: 'pointer' }}
                onClick={(e) => {
                  const tag = e.target.tagName.toLowerCase();
                  if (!['button', 'svg', 'path', 'a'].includes(tag)) {
                    handleAbrirANP(anp);
                  }
                }}
              >
                {anp.codigoIM}
              </td>

              <td
              style={{ padding: '7px 8px', cursor: 'pointer' }}
              onClick={(e) => {
                const tag = e.target.tagName.toLowerCase();
                if (!['button', 'svg', 'path', 'a'].includes(tag)) {
                  handleAbrirANP(anp);
                }
              }}
            >
              {anp.codigoCV}
            </td>

            <td
            style={{ padding: '7px 8px', cursor: 'pointer' }}
            onClick={(e) => {
              const tag = e.target.tagName.toLowerCase();
              if (!['button', 'svg', 'path', 'a'].includes(tag)) {
                handleAbrirANP(anp);
              }
            }}
          >
            {anp.op}
          </td>

          <td
          style={{ padding: '7px 8px', color: '#888', fontSize: 14, cursor: 'pointer' }}
          onClick={(e) => {
            const tag = e.target.tagName.toLowerCase();
            if (!['button', 'svg', 'path', 'a'].includes(tag)) {
              handleAbrirANP(anp);
            }
          }}
        >
          {anp.data}
        </td>

                     <td style={{ padding: '7px 4px', textAlign: 'center', whiteSpace: 'nowrap' }}>

  {tiposUsuario.some(t => ['admin', 'projetos', 'qualidade'].includes(t)) && (

    <>
      <button
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
if (anp.arquivo) {
  const urlAbsoluta = anp.arquivo.startsWith('http')
    ? anp.arquivo
    : `https://projetos.impram.com.br${anp.arquivo}`;
  window.open(urlAbsoluta, '_blank');
} else {
  alert("Nenhum anexo encontrado!");
}

        }}
        style={{
          background: '#ffffff',
          border: '2px solid #1976d2',
          borderRadius: 10,
          padding: '3px 6px',
          marginRight: 6,
          cursor: 'pointer',
          color: '#1976d2',
          fontWeight: '900',
          fontSize: 17,
          boxShadow: '0px 1px 5px rgba(25, 118, 210, 0.3)'
        }}
        title="Ver Desenho Técnico"
      >
        🔗
      </button>

      <button
        onClick={e => {
          e.stopPropagation();
          handleDuplicarANP(anp);
        }}
        style={{
          background: '#ffffff',
          border: '2px solid #4caf50',
          borderRadius: 10,
          padding: '3px 6px',
          marginRight: 6,
          cursor: 'pointer',
          color: '#4caf50',
          fontWeight: '900',
          fontSize: 17,
          boxShadow: '0px 1px 5px rgba(76, 175, 80, 0.3)'
        }}
        title="Duplicar esta ANP"
      >
        📄
      </button>

      <button
        onClick={e => {
          e.stopPropagation();
          handleRemoverANP(anp.id);
        }}
        style={{
          background: '#ffffff',
          border: '2px solid #c62828',
          borderRadius: 10,
          padding: '3px 6px',
          cursor: 'pointer',
          color: '#c62828',
          fontWeight: '900',
          fontSize: 17,
          boxShadow: '0px 1px 5px rgba(198, 40, 40, 0.3)'
        }}
        title="Mover para a Lixeira"
      >
        🗑️
      </button>
    </>
  )}
</td>



                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          <div style={{ textAlign: 'center' }}>
            

          </div>
        </>
      ) : (
        <>
          <button
           onClick={() => {
  setShowForm(false); // apenas fecha, mantém dados
}}

            style={{ marginBottom: 18, background: '#eee', border: 0, borderRadius: '7px', padding: '8px 18px', cursor: 'pointer' }}
          >← Voltar à lista</button>


<CabecalhoProjeto
  dados={cabecalho}
  onChange={handleCabecalhoChange}
  editavel={
    tiposUsuario.some(t => ['admin', 'projetos', 'qualidade'].includes(t)) ||
    Object.keys(dadosForm || {}).length === 0 ||
    Object.keys(dadosForm || {}).some(proc => {
      const procNorm = normalizeNome(proc);
      const tipoNorm = normalizeNome(usuarioAtual?.tipo);
      const processoNorm = normalizeNome(usuarioAtual?.processo);

      if (Array.isArray(tipoNorm)) {
        return tipoNorm.some(tipo => 
          procNorm === tipo ||
          procNorm === tipo.replace(/_/g, "_e_")
        );
      } else {
        const tipoNormComE = tipoNorm.replace(/_/g, "_e_");
        return (
          procNorm === tipoNorm ||
          procNorm === tipoNormComE ||
          procNorm === processoNorm
        );
      }
    })
  }
onFileUrlChange={(url) => {
  alert('📎 PDF enviado com sucesso!');
  setArquivoAnexo(url);
  setCabecalho(prev => ({ ...prev, urlArquivo: url }));
  setAnpSelecionada(prev => ({
    ...prev,
    arquivo: url,
    cabecalho: {
      ...(prev?.cabecalho || {}),
      urlArquivo: url
    }
  }));
}}


/>



{arquivoAnexo && (
  <div style={{ maxWidth: 950, margin: '0 auto', marginTop: 30 }}>
    <div style={{ position: 'relative', width: '100%', paddingTop: '77%' /* Proporção A4 */ }}>
      <iframe
        key={arquivoAnexo}
        src={`${arquivoAnexo.startsWith('http') ? arquivoAnexo : 'https://projetos.impram.com.br' + arquivoAnexo}#view=FitH&toolbar=1`}
        title="Desenho Técnico"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: '1px solid #ccc',
          borderRadius: 8,
          display: 'block'
        }}
        loading="eager"
      />
    </div>
  </div>
)}










<ProcessoForm
  resumoAcoes={Array.isArray(acoesProcessos) ? acoesProcessos : []}
  onSalvar={handleSalvar}
  dadosIniciais={dadosForm}
  usuario={usuarioAtual}
  somenteLeitura={
    !(
      tiposUsuario.some(t => ['admin', 'projetos', 'qualidade'].includes(t)) ||
      Object.keys(dadosForm || {}).length === 0 || // ← libera se está vazio (criação)
      Object.keys(dadosForm || {}).some(proc => {
        const procNorm = normalizeNome(proc);
        const tipoNorm = normalizeNome(usuarioAtual?.tipo);

        if (Array.isArray(tipoNorm)) {
          return tipoNorm.some(tipo =>
            procNorm === tipo || procNorm === tipo.replace(/_/g, "_e_")
          );
        } else {
          return (
            procNorm === tipoNorm ||
            procNorm === tipoNorm.replace(/_/g, "_e_")
          );
        }
      })
    )
  }
  processosPermitidos={
    ['admin', 'projetos', 'qualidade'].some(tipo => tiposUsuario.includes(tipo))
      ? Object.keys(dadosForm || {})
      : Object.keys(dadosForm || {}).filter(proc => {
          const procNorm = normalizeNome(proc);
          const processoNorm = normalizeNome(usuarioAtual?.processo || '');

          console.log("🔍 Comparando permissões:");
          console.log("  🔸 Processo ANP:", proc, "→", procNorm);
          console.log("  🔹 Tipos usuário:", tiposUsuario);
          console.log("  🔹 Processo usuário:", usuarioAtual?.processo, "→", processoNorm);

          return (
            tiposUsuario.includes(procNorm) ||
            tiposUsuario.includes(procNorm.replace(/_/g, "_e_")) ||
            (processoNorm && procNorm === processoNorm)
          );
        })
  }



  processosIniciais={Object.keys(dadosForm || {})}
  anpSelecionada={anpSelecionada}
  setMostrarResumoAcoes={setMostrarResumoAcoes}
  setShowForm={setShowForm}
  handleAbrirAcoes={(processo) => {
    console.log('🚀 Abrindo modal de ações para:', processo);
    setProcessoSelecionadoParaAcoes(processo);
    setModalAcoesAberto(true);
  }}
/>






        </>
      )}
    </div>
  );
}

export default App;
